const PROTOCOL_PATTERN = /^\w+(?=:\/\/)/

export const addProtocolIfNeed = (
  value: string | null,
  defaultProtocol = 'https'
): string => {
  if (!value || !value.trim()) {
    return ''
  }
  const hasProtocol = !!value.match(PROTOCOL_PATTERN)
  return hasProtocol ? value : `${defaultProtocol}://${value}`
}

export const parseProtocol = (url: string): string | null => {
  const match = url.match(PROTOCOL_PATTERN)
  return match?.[0] || null
}
